module.exports = __webpack_public_path__ + "img/sdk-1-3.1a0f478.svg";